import {
	// 创建批单
	createCargoOrderApi,
	// 计算批单保费
	calcCargoOrderApi,
	// 获得批单申请分页
	cargoOrderPageApi,
	// 批单申请确认
	cargoOrderConfirmApi,
	// 取消批单
	cargoOrderCancelApi,
	// 查询保单(批单)
	cargoOrderApi,
	// 修改批单申请
	cargoOrderUpdateApi,
	// 取消凭证
	cargoOrderPolicyCancelApi
} from '@/apis/ins.js'
export default {
	async createCargoOrder(context, body) {
		return createCargoOrderApi(body)
	},
	async calcCargoOrder(context, body) {
		return calcCargoOrderApi(body)
	},
	async cargoOrderPage(context, params) {
		return cargoOrderPageApi(params)
	},
	async cargoOrderConfirm(context, id) {
		return cargoOrderConfirmApi(id)
	},
	async cargoOrderCancel(context, id) {
		return cargoOrderCancelApi(id)
	},
	async cargoOrder(context, id) {
		return cargoOrderApi(id)
	},
	async cargoOrderUpdate(context, {id, body}) {
		return cargoOrderUpdateApi(id, body)
	},
	async cargoOrderPolicyCancel(context, id) {
		return cargoOrderPolicyCancelApi(id)
	}
}